import React, { useState } from 'react';
import { Box, Button, Typography, alpha } from '@mui/material';
import { LinkOutlined } from '@mui/icons-material';
import useAutoFetch from '../../../hooks/useAutoFetch';
import { useModulePermissions } from '../../../hooks/useModulePermissions';
import { admissionInviteService } from '../../../services/admissions/admissionInviteService';
import FormLinksDialog from './FormLinksDialog';

/**
 * Above the applications: how many form links are still with families, one
 * click from the list. Shows nothing when none are waiting.
 */
const FormLinksStrip: React.FC<{ cycleId: string }> = ({ cycleId }) => {
  const { canWrite } = useModulePermissions();
  const [open, setOpen] = useState(false);
  const [tick, setTick] = useState(0);
  const { data } = useAutoFetch(`form-links-count:${cycleId}:${tick}`, () => admissionInviteService.list(cycleId, { limit: 1 }));
  const waiting = data?.pagination.totalItems ?? 0;
  if (!waiting && !open) return null;

  return (
    <>
      {waiting > 0 && (
        <Box sx={(t) => ({
          display: 'flex', alignItems: 'center', gap: 1.25, px: 2.5, py: 1, borderBottom: 1, borderColor: 'divider',
          bgcolor: alpha(t.palette.primary.main, 0.035),
        })}>
          <LinkOutlined sx={{ fontSize: 18, color: 'primary.main' }} />
          <Typography variant="body2" sx={{ flex: 1 }}>
            <b>{waiting}</b> form link{waiting === 1 ? '' : 's'} waiting for {waiting === 1 ? 'a family' : 'families'} to fill in
          </Typography>
          <Button size="small" onClick={() => setOpen(true)} sx={{ textTransform: 'none', fontWeight: 600 }}>View</Button>
        </Box>
      )}
      {open && (
        <FormLinksDialog
          cycleId={cycleId}
          canManage={canWrite('admissions')}
          onClose={() => setOpen(false)}
          onChanged={() => setTick(t => t + 1)}
        />
      )}
    </>
  );
};

export default FormLinksStrip;
